import Easy from "public/disaster-recovery/disasterRecoveryEasy.svg";
import Efficient from "public/disaster-recovery/disasterRecoveryEfficient.svg";
import Secure from "public/disaster-recovery/disasterRecoverySecure.svg";

export const FAQ_DATA = [
  {
    title: "What’s the difference between backup and disaster recovery solutions?",
    content: [
      "Backups are simple; they are copy of your corporate systems and data that can be used to bring a failed system back online. Disaster recovery refers to a more advanced form of system copies that include processing capabilities.",
    ],
  },
  {
    title: "What is a disaster recovery solution?",
    content: [
      "Disaster recovery solutions allow companies to quickly resume business-critical workloads after cyberattacks, natural disasters, or server failures. The disaster recovery process normally involves a separate physical or cloud site to restore data. Every disaster recovery solution aims to help businesses operate as usual. Since business continuity depends on high availability, disaster recovery strategies depend on tight RPOs and RTOs.",
    ],
  },
  {
    title: "What goes into a disaster recovery plan?",
    content: [
      "Your business has its own unique data requirements, so a good plan will minimize the complexity of the disaster recovery process. To define the correct approach to creating a disaster recovery plan for your business, you will need to assess the applications, process, and cost versus risk.",
    ],
  },
  {
    title: "What data should I back up for effective disaster recovery?",
    content: [
      "For reliable disaster recovery, you need to look beyond simply copying all of your databases and files. Your entire infrastructure – servers, PCs, NAS, SAN, hypervisors, and endpoints – contains vital production data. You’ll need to capture application settings, operating system configurations, bookmarks, and registry data for a full recovery.",
    ],
  },
  {
    title: "What’s the difference between RPO and RTO?",
    content: [
      "A Recovery Point Objective (RPO) is the point in time that data, systems, and applications will be recovered to. A Recovery Time Objective (RTO) is how much time can pass before your business must be restored.",
    ],
  },
  {
    title: "What is the best method for disaster recovery?",
    content: [
      "There are three different ways you can store business-critical data: local data center, in the cloud, or you can take a hybrid approach.",
      "With a data center, your critical data is stored off-site in a physical location, but disaster recovery can take days or weeks. Although this is considered the most secure storage option, it is also the most expensive as facilities, and additional systems and staff are required.",
      "Cloud disaster recovery is the most cost-effective and scalable option. With this option, you leverage a cloud data center to store your critical systems (whether physical or virtual), data, and applications. Cloud disaster recovery allows you to keep entire virtual environments at the ready, reducing recovery from a disaster or business outage to minutes or even seconds.",
      "A hybrid cloud disaster recovery method uses a public cloud and private data center (physical or cloud). This provides a great degree of flexibility, keeps costs down, while also meeting any regulatory and compliance needs.",
      "With all three methods, be sure to evaluate the pros and cons of each against your individual business requirements.",
    ],
  },
];

export const DISASTER_RECOVERY_OPERATIONS = [
  {
    title: "DRaaS Orchestration With Run-Books",
    content:
      "Automate key disaster recovery scenarios and ensure the systems are recovered in the right order to address interdependencies between applications.",
  },
  {
    title: "Backup-Based Replication Of Production Machines",
    content:
      "Benefit from the perfect combination of short recovery times and much lower costs when compared with sophisticated replication technologies.",
  },
  {
    title: "Instant Off-Site Failover To The Cloud Recovery Site",
    content:
      "Get back to business in mere minutes in the event of a site outage by switching your production workloads to virtual machines in a cloud data center.",
  },
];
export const DISASTER_RECOVERY_FEATURES = [
  {
    image: Easy,
    title: "Easy",
    content:
      "Manage your disaster recovery as a service (DRaaS) through a single user interface.",
  },
  {
    image: Efficient,
    title: "Efficient",
    content:
      "No need to add, learn, or manage another platform or vendor, it’s one solution.",
  },
  {
    image: Secure,
    title: "Secure",
    content:
      "Safeguard data and systems in any environment, physical or virtual, on-premises or in the cloud.",
  },
];
